import React from 'react';
import '../index.css';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export class MainMenu extends React.Component {
    constructor( props ) {
        super( props );
        this.state = { showInfoModal: false }
    }

    onCloseModal = () => {
        this.setState({ showInfoModal: false });
    }

    onYes = () => {
        window.location.replace('https://epictogethernj.org');
    }
    
    onNo = () => {
        this.setState({ showInfoModal: false });
        this.props.menuSelection('NEW');
    }

    onClick = ( event ) => {
        var value = event.target.value;
        if(value === 'NEW') {
            this.setState({ showInfoModal: true })
        }else{
            this.props.menuSelection( value );
        }
    }

    render() {
        return(
            <>
                <h3 className='MainMenuTitle'>Epic Carelink Hyperspace Access Request Portal (EC-HARP)</h3>

                <p className='MainMenuDisclaimer'>
                RWJBarnabas Health CareLink provides Web access to your patients’ real-time medical records, test results and imaging reports, 
                and receive email notification of your patients’ outpatient visits, hospital admissions and discharges. Once RWJBarnabas Health verifies your 
                information and creates a user ID, you will have full access to the site. CareLink is free and online, with no software to install.
                </p>

                {
                    this.state.showInfoModal ? 
                    <>
                    <Modal show={true}>
                      <Modal.Header style={styles.modalBorders} onClick = { this.onCloseModal } closeButton>
                        <Modal.Title style={styles.modalTitleTextColor}>New Site Access</Modal.Title>
                      </Modal.Header>
                      <Modal.Body style={styles.modalBodyTextColor}>Are you an employed practice of <b>RWJ Barnabas Health/Medical Group</b>?</Modal.Body>
                      <Modal.Footer style = {styles.modalBorders}>
                        <Button style = {styles.noBtnBgColor} onClick = { this.onNo } variant="secondary">
                          No
                        </Button>
                        <Button style = {styles.yesBtnBgColor} onClick = { this.onYes } variant="primary">
                          Yes
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </> : <></>
                }

                <Button 
                    variant='danger' 
                    className='MainMenuButtonProperties shadow'
                    value='NEW'
                    onClick={ this.onClick }
                > 
                    New Site Access 
                </Button>
            
                <Button 
                    variant='danger' 
                    className='MainMenuButtonProperties shadow'
                    value='UPDATE'
                    onClick={ this.onClick }
                > 
                    Update Site Access 
                </Button>
            
                <Button 
                    variant='danger' 
                    className='MainMenuButtonProperties shadow'
                    value='CHECK'
                    onClick={ this.onClick }
                > 
                    Check Request Status/Complete Annual Renewal 
                </Button>

                <Button 
                    variant='danger' 
                    className='MainMenuButtonProperties shadow'
                    value='CREATE'
                    onClick={ this.onClick }
                > 
                    Research Access
                </Button>
            </>
        );
    }
}


const styles = {
    modalBorders: {
      borderTop: 0,
      borderBottom: 0
    },
    noBtnBgColor: {
      backgroundColor: "#D02B2E",
      borderColor: "#D02B2E"
    },
    yesBtnBgColor: {
      backgroundColor: "#00536D",
      borderColor: "#00536D"
    },
    modalTitleTextColor: {
      color: "#00536D"
    },
    modalBodyTextColor: {
      color: "#00536D"
    }
  };